class ProductBreadcrumbs extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['collections', 'collectionLink']
  }

  connectedCallback () {
    super.connectedCallback()

    this.updateCollection()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(window, 'pagehide', this.onPageHide.bind(this))
  }

  onPageHide () {
    try {
      sessionStorage.removeItem('nm-pdp-collection')
    } catch (error) {}
  }

  updateCollection () {
    const collections = this.collections
    const collection = this.getCollection(collections)

    if (!collection) return

    const link = this.els.collectionLink.element
    const item = this.els.collectionItem?.element

    if (link.getAttribute('href') === collection.url) return

    const width = item && !item.hidden ? item.getBoundingClientRect().width : 0

    if (!width || !item.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.applyCollection(collection)
      return
    }

    this.animateCollection(collection, item, link, width)
  }

  animateCollection (collection, item, link, width) {
    const previous = link.cloneNode(true)
    const easing = getComputedStyle(this).getPropertyValue('--ease-out-slow').trim() || 'ease-out'

    previous.removeAttribute('href')
    previous.removeAttribute('data-product-breadcrumbs-el')
    previous.classList.add('prd-Breadcrumbs_Link-previous')
    previous.setAttribute('aria-hidden', 'true')

    this.applyCollection(collection)
    item.setAttribute('data-swap', '')
    item.append(previous)

    const offset = width - item.getBoundingClientRect().width
    const followers = this.querySelectorAll(`${this.els.collectionItem.selector} ~ *`)
    const animations = [
      previous.animate({ opacity: [1, 0] }, { duration: 120, easing, fill: 'forwards' }),
      link.animate({ opacity: [0, 1] }, { duration: 180, delay: 80, easing, fill: 'backwards' }),
      ...Array.from(followers, (follower) => follower.animate(
        { transform: [`translateX(${offset}px)`, 'translateX(0)'] },
        { duration: 180, delay: 80, easing, fill: 'backwards' },
      )),
    ]

    Promise.allSettled(animations.map((animation) => animation.finished)).then(() => {
      previous.remove()
      item.removeAttribute('data-swap')
    })
  }

  applyCollection (collection) {
    this.els.collectionLink.element.href = collection.url
    this.els.collectionLink.element.textContent = collection.title
    this.els.collectionItem?.element.removeAttribute('hidden')
    this.els.separator?.element.removeAttribute('hidden')
  }

  getCollection (collections) {
    const referrerHandle = this.getReferrerHandle()

    if (referrerHandle) {
      return (
        this.findCollection(collections, referrerHandle) ||
        this.getStoredCollection(referrerHandle)
      )
    }

    if (document.referrer) return null

    const stored = this.getStoredCollection()

    if (!stored) return null

    return this.findCollection(collections, stored.handle) || stored
  }

  findCollection (collections, handle) {
    return (
      collections.find((collection) => collection?.handle === handle) || null
    )
  }

  getReferrerHandle () {
    if (!document.referrer) return null

    try {
      const referrerUrl = new URL(document.referrer)

      if (referrerUrl.origin !== window.location.origin) return null

      const match = referrerUrl.pathname.match(/\/collections\/([^/]+)/)

      return match ? decodeURIComponent(match[1]) : null
    } catch (error) {
      return null
    }
  }

  getStoredCollection (handle) {
    try {
      const stored = JSON.parse(sessionStorage.getItem('nm-pdp-collection'))

      if (!stored?.handle || !stored.title || !stored.url) return null
      if (handle && stored.handle !== handle) return null

      return stored
    } catch (error) {
      return null
    }
  }

  get collections () {
    try {
      const collections = JSON.parse(this.els.collections.element.textContent)

      return Array.isArray(collections) ? collections : []
    } catch (error) {
      return []
    }
  }
}

if (!customElements.get('product-breadcrumbs')) {
  customElements.define('product-breadcrumbs', ProductBreadcrumbs)
}
